export default __webpack_public_path__ + "static/media/women-2.a4e51520.jpg";